export const resourcesList = [
  {
    name: "www.política123.com/site/...",
    type: "Link público",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Estatuto.xls",
    type: "Documento",
    source: "Público",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Código de Ética.pdf",
    type: "Declaración Jurada",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Código de Ética.pdf",
    type: "Declaración Jurada",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Código de Ética.pdf",
    type: "Declaración Jurada",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Código de Ética.pdf",
    type: "Declaración Jurada",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Código de Ética.pdf",
    type: "Declaración Jurada",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Código de Ética.pdf",
    type: "Declaración Jurada",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Código de Ética.pdf",
    type: "Declaración Jurada",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
  {
    name: "Código de Ética.pdf",
    type: "Declaración Jurada",
    source: "Interno",
    date: "11-11-2024",
    editions: [2023, 2022, 2021, 2019, 2018, 2017, 2026],
  },
];

export const typesFilters = [
  {
    title: "Link público",
    id: "PUBLIC_LINK",
  },
  {
    title: "Documento",
    id: "DOCUMENT",
  },
  {
    title: "Declaración Jurada",
    id: "SWORN_DECLARATION",
  },
];

export const foldersFilters = [
  {
    title: "Carpeta 1",
    id: "FOLDER_1",
  },
  {
    title: "Carpeta 2",
    id: "FOLDER_2",
  },
  {
    title: "Carpeta 3",
    id: "FOLDER_3",
  },
  {
    title: "Carpeta 4",
    id: "FOLDER_4",
  },
];

export const dateFilters = [
  {
    title: "Más nuevo al más antiguo",
    id: "OLD",
  },
  {
    title: "Más antiguo al más nuevo",
    id: "NEW",
  },
];

export const editionsFilters = [
  {
    title: "2023",
    id: 2023,
  },
  {
    title: "2022",
    id: 2022,
  },
  {
    title: "2021",
    id: 2021,
  },
];

export const sourceFilters = [
  {
    title: "Interno",
    id: "INTERNAL",
  },
  {
    title: "Público",
    id: "PUBLIC",
  },
];
